<template>
  <el-dialog :visible.sync="syncs">
    <!-- <div slot="title">22222</div> -->
    <div slot="footer">1111</div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      syncs: true
    }
  }
}
</script>

<style>

</style>
